<template>
<div id="purchases">

  <h2>
    <span
      v-if="tag"
    >
      {{ tag.name }}
    </span>
    Purchases
  </h2>

  <purchase-nav />
  <purchase-search
    ref="purchaseSearch"
  />
  <purchasable-item-select />

  <div
    v-if="filter"
  >
    <p>
      <label
        for="status"
      >
        Filter by status: <a
          href="#"
          v-on:click.prevent="getItemlessPurchases"
        >
          Itemless Purchases (Debug Only)
        </a>
      </label>
      <purchase-status-select
        selectName="statuses[]"
        noFilter="true"
        :requestedStatuses="statuses"
        multiple
      />
    </p>
    <button
      type="button"
      class="btn btn-sm btn-primary float-right"
      @click="toggleFilter"
    >
      <span>
        {{filter ? 'Hide' : 'Show'}} Filters
      </span>
    </button>
  </div>
  <div
    v-else
  >
    <purchase-key />
  </div>

  <paged-purchases
    ref="pagination"
    method="post"
    :formdata="formdata"
    :resourceUrl="purchasesByStatusUrl"
    preserveHistory
  />

  <payment-lookup
    :paymentId="query"
    v-if="showPaymentLookup"
  />
</div>
</template>

<script>

import PaymentLookup from '@/components/PaymentLookup'
import PurchasableItemSelect from '@/components/PurchasableItemSelect'
import PurchaseKey from '@/components/PurchaseKey'
import PurchaseListItem from '@/components/PurchaseListItem'
import PurchaseNav from '@/components/PurchaseNav'
import PurchaseSearch from '@/components/PurchaseSearch'
import PurchaseStatusSelect from '@/components/PurchaseStatusSelect'
import PurchasesPaged from '@/components/PurchasesPaged'

export default {
  data () {
    return {
      filter: false,
      item: undefined,
      itemsCount: undefined,
      query: undefined,
      queryType: undefined,
      showBuyer: false,
      status: undefined,
      statuses: ['completed', 'send_confirmation', 'refunded']
    }
  },

  props: {
    tagId: {
      type: String,
      default: undefined
    }
  },

  components: {
    'paged-purchases': PurchasesPaged,
    'payment-lookup': PaymentLookup,
    'purchase-key': PurchaseKey,
    'purchase-list': PurchaseListItem,
    'purchasable-item-select': PurchasableItemSelect,
    'purchase-nav': PurchaseNav,
    'purchase-search': PurchaseSearch,
    'purchase-status-select': PurchaseStatusSelect
  },

  computed: {
    itemlessPurchasesUrl () {
      return this.apiUrl('/itemless_purchases', true)
    },

    formdata () {
      return {
        statuses: this.statuses
      }
    },

    purchasesByItemUrl () {
      return this.apiUrl(
        '/purchases_by_item/' + this.item,
        true
      )
    },

    purchasesByStatusUrl () {
      return this.apiUrl(
        '/' + (
          this.tagId ? ('tags/' + this.tagId + '/') : ''
        ) + 'purchases_by_statuses',
        true
      )
    },

    purchasesUrl () {
      return this.apiUrl(
        (
          this.tagId ? (
            '/tags/' + this.tagId + '/purchases'
          ) : '/purchases'
        ), true
      )
    },

    showPaymentLookup () {
      return this.queryType === 'payments' && this.query && this.itemsCount === '0'
    }
  },

  created () {
    if (this.tagId) { this.getTag() }

    this.$on('purchaseStatusChange', this.onPurchaseStatusChange)
    this.$on('purchaseItemChange', this.onPurchaseItemChange)
    this.$on('onPageSuccess', this.onPageSuccess)
  },

  methods: {
    getItemlessPurchases () {
      this.purchases = []

      const cfg = {
        paging_method: 'get',
        resource_url: this.itemlessPurchasesUrl
      }

      this.$refs.pagination.$emit('changeConfig', cfg)
      this.$refs.pagination.$emit('requestPage')
    },

    getTag () {
      this.apiGet(
        '/admin/tags/' + this.tagId
      ).then((resp) => {
        this.tag = resp
      })
    },

    onPageSuccess (response) {
      this.itemsCount = response.headers.get('x-total-items-count')
    },

    onPurchaseItemChange (item) {
      this.purchases = []
      var cfg = this.config
      this.item = item

      cfg = {
        paging_method: 'get',
        resource_url: this.purchasesByItemUrl
      }

      this.$refs.pagination.$emit('changeConfig', cfg)
      this.$refs.pagination.$emit('requestPage')
    },

    onPurchaseStatusChange (statuses) {
      this.purchases = []
      var cfg = this.config
      this.statuses = statuses

      let unfiltered = this.statuses.includes('all')
      let url = unfiltered ? this.purchasesUrl : this.purchasesByStatusUrl
      let method = unfiltered ? 'get' : 'post'

      cfg = {
        formdata: this.formdata,
        paging_method: method,
        resource_url: url
      }

      this.$refs.pagination.$emit('changeConfig', cfg)
      this.$refs.pagination.$emit('requestPage')
    },

    toggleFilter () {
      this.filter = !(this.filter === true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Purchases.vue